import {
  ActionChip,
  BREAKPOINTS,
  ComponentMStyling,
  ComponentSStyling,
  ComponentTextStyle,
  Size,
  StyledLink,
  SystemIcons
} from '@laerdal/life-react-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaMatch } from 'rooks';
import styled from 'styled-components';
import { useSelector } from "react-redux";
import { Navigate, useNavigate } from 'react-router-dom';
import { selectUserPermissions, selectUserProfile, selectIsAuthenticated } from '../store/slices/userSlice';
import { OrganizationPermissions } from '../model/constants/organizationPermissions';
import posthog from 'posthog-js';

const WidgetContainer = styled.div`
  background: #e4f6f6;
  border-radius: 8px;
  width: 100%;
`;

const WidgetContent = styled.div`
  margin: 24px;
  align-items: stretch; 
  display: flex;
  flex-direction: column;
    gap: 8px;

  ${BREAKPOINTS.MEDIUM} {
    flex-wrap: wrap;
    flex-direction: row;
    align-items: start;
    
  }
`;


const Chip = styled(ActionChip)`
  div {
    width: 100%;
  }

  div > div {
    width: 100%;
    flex-direction: row;
    justify-content: center;
  }

  div > div > div {
    width: unset;
  }
`;

const QuickLinks = () => {
  const { t } = useTranslation('landingPage');
  const isMediumScreen = useMediaMatch(BREAKPOINTS.MEDIUM.replace('@media ', ''));
  const navigate = useNavigate();
  const user = useSelector(selectUserProfile);
  const permissions = useSelector(selectUserPermissions);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  return (
    <WidgetContainer>
      <WidgetContent>

        {(permissions?.includes(OrganizationPermissions.AccountOwner)
          || permissions?.includes(OrganizationPermissions.ViewProducts)) &&
          <Chip
            icon={<SystemIcons.Manikin />}
            size={Size.Medium}
            text={t('My Products')}
            onClick={() => {
              const hasProductPermission = permissions?.includes(OrganizationPermissions.AccountOwner)
                || permissions?.includes(OrganizationPermissions.ViewProducts);
              const link = `${process.env.REACT_APP_CONNECT_LINK}/products`;
              posthog?.capture('SUPP-QuickLinks-MyProductsClick', {
                component: 'QuickLinks',
                hasPermission: hasProductPermission,
                link: link
              });
              window.location.href = link;
            }}></Chip>
        }

        {(permissions?.includes(OrganizationPermissions.AccountOwner)
          || permissions?.includes(OrganizationPermissions.ViewOrders)) &&
          <Chip
            icon={<SystemIcons.ListView />}
            size={Size.Medium}
            text={t('Orders & Invoices')}
            onClick={() => {
              const hasOrderPermission = permissions?.includes(OrganizationPermissions.AccountOwner)
                || permissions?.includes(OrganizationPermissions.ViewOrders);
              const link = `${process.env.REACT_APP_ACCOUNT_BASE}/ordersinvoices`;
              posthog?.capture('SUPP-QuickLinks-OrdersInvoicesClick', {
                component: 'QuickLinks',
                hasPermission: hasOrderPermission,
                link: link
              });
              window.location.href = link;
            }}></Chip>
        }

        <Chip
          icon={<SystemIcons.Mail />}
          size={Size.Medium}
          text={t('My Cases')}
          onClick={() => {
            const link = isAuthenticated 
              ? `${process.env.REACT_APP_ACCOUNT_BASE}/cases`
              : `${process.env.REACT_APP_CONNECT_LINK}`;
            posthog?.capture('SUPP-QuickLinks-MyCasesClick', {
              component: 'QuickLinks',
              isAuthenticated: isAuthenticated,
              link: link
            });
            window.location.href = link;
          }}></Chip>






        {(permissions?.includes(OrganizationPermissions.ManageAccess)
          || permissions?.includes(OrganizationPermissions.AccountOwner)) &&
          <Chip
            icon={<SystemIcons.AddUser />}
            size={Size.Medium}
            text={t('Invite a Colleague')}
            onClick={() => {
              posthog?.capture('SUPP-QuickLinks-InviteColleagueClick', {
                component: 'QuickLinks',
                link: `${process.env.REACT_APP_ACCOUNT_BASE}/users`
              });
              window.location.href = `${process.env.REACT_APP_ACCOUNT_BASE}/users`;
            }}></Chip>
        }

        <Chip
          icon={<SystemIcons.Support />}
          size={Size.Medium}
          text={t('Contact Support')}
          onClick={() => {
            posthog?.capture('SUPP-QuickLinks-ContactSupportClick', {
              component: 'QuickLinks'
            });
            navigate("/case/create");
          }}></Chip>
      </WidgetContent>
    </WidgetContainer>
  );
};

export default QuickLinks;
